// extracted by mini-css-extract-plugin
export var wrapper = "logo_grid-module--wrapper--ecGAj";